var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdCardSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 7,
    fill: "#F76D57",
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    fill: "#F76D57",
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M62,55c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V15c0-1.104,0.896-2,2-2h8v3c0,0.553,0.447,1,1,1h6 c0.553,0,1-0.447,1-1v-3h24v3c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1v-3h8c1.104,0,2,0.896,2,2V55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M14.521,44.374C15.457,43.08,17.639,41,22,41c4.363,0,6.545,2.082,7.48,3.374 C27.428,46.014,24.831,47,22,47S16.572,46.014,14.521,44.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#506C7F",
    d: "M30.936,42.989C29.657,41.326,26.986,39,22,39s-7.657,2.326-8.936,3.989C11.165,40.867,10,38.072,10,35 c0-6.627,5.373-12,12-12s12,5.373,12,12C34,38.072,32.835,40.867,30.936,42.989z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60,11h-8V6c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5H20V6c0-0.553-0.447-1-1-1h-6 c-0.553,0-1,0.447-1,1v5H4c-2.211,0-4,1.789-4,4v40c0,2.211,1.789,4,4,4h56c2.211,0,4-1.789,4-4V15C64,12.789,62.211,11,60,11z  M46,7h4v8h-4V7z M14,7h4v8h-4V7z M62,55c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V15c0-1.104,0.896-2,2-2h8v3 c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1v-3h24v3c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1v-3h8c1.104,0,2,0.896,2,2V55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M41,39h10c0.553,0,1-0.447,1-1s-0.447-1-1-1H41c-0.553,0-1,0.447-1,1S40.447,39,41,39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M55,31H41c-0.553,0-1,0.447-1,1s0.447,1,1,1h14c0.553,0,1-0.447,1-1S55.553,31,55,31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M55,43H41c-0.553,0-1,0.447-1,1s0.447,1,1,1h14c0.553,0,1-0.447,1-1S55.553,43,55,43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M41,27h6c0.553,0,1-0.447,1-1s-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1S40.447,27,41,27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M22,21c-7.731,0-14,6.269-14,14s6.269,14,14,14s14-6.269,14-14S29.731,21,22,21z M22,47 c-2.831,0-5.428-0.986-7.479-2.626C15.457,43.08,17.639,41,22,41c4.363,0,6.545,2.082,7.48,3.374C27.428,46.014,24.831,47,22,47z  M30.936,42.989C29.657,41.326,26.986,39,22,39s-7.657,2.326-8.936,3.989C11.165,40.867,10,38.072,10,35c0-6.627,5.373-12,12-12 s12,5.373,12,12C34,38.072,32.835,40.867,30.936,42.989z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M27,34v-2c0-2.762-2.238-5-5-5s-5,2.238-5,5v2c0,2.762,2.238,5,5,5S27,36.762,27,34z M25,34 c0,1.657-1.343,3-3,3s-3-1.343-3-3v-2c0-1.657,1.343-3,3-3s3,1.343,3,3V34z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M25,34c0,1.657-1.343,3-3,3s-3-1.343-3-3v-2c0-1.657,1.343-3,3-3s3,1.343,3,3V34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardSvgrepoCom);
export default __webpack_public_path__ + "static/media/id-card-svgrepo-com.7c991f7a306a695fa349f16b8aef7295.svg";
export { ForwardRef as ReactComponent };